//Local
// export const ApiUrl = "http://localhost:8005"
//Live
export const ApiUrl = "https://api.gfw-dev.co.uk"
//Staging
//export const ApiUrl = "https://test.gfw-dev.co.uk"
